import React from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    SurgeryTitle,
    SurgerySubTitle,
    DetailsMainContainerBlock,
    MainContainerItems,
} from '../surgeryDetails/SurgeryDetails.styled';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
  
export default function ConsignmentTermData({ term, isConsignmentBilling }) {
    const [expandedCard, setExpandedCard] = useState(true);
    const { t } = useTranslation();
    const toggleCard = () => {
        setExpandedCard(!expandedCard);
    };
    const isCondensedView = useSelector(
            (state) => state.loginReducer.isCondensedView
        );

    return (
        <>
            {' '}
            <CollapsableCard
                id="orders-consignmentTerm-consignmentTerm-term"
                title={t('reportUsage.consignmentTerm')}
                onClick={() => toggleCard(!expandedCard)}
                isExpanded={expandedCard}
                padding={'0.8rem'}
                cursor={'pointer'}

                mobileMargin={!isConsignmentBilling && isCondensedView ? '10px 16px 2px 16px': ''}
            >
                   {expandedCard ? <DetailsMainContainerBlock>
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t('reportUsage.termLength')}
                                </SurgeryTitle>
                                <SurgerySubTitle>
                                    {term ? term : null}{' '}
                                </SurgerySubTitle>
                            </MainContainerItems>
                    </DetailsMainContainerBlock> : null}
            </CollapsableCard>
        </>
    );
}
